<app-spinner [showSpinner]="loading"></app-spinner>
<div>
  <modal-header [showBackButton]="false" [title]="'addTransaction' | i18n"></modal-header>
  <div class="modal-body" [ngClass]="data.isFromGuide ? 'guide-modal-safe-area' : ''">
    <div class="tw-flex tw-flex-col tw-gap-6">
      <!-- Tab toggle: Transaction Details / Categories (sliding thumb) -->
      <div
        class="tw-relative tw-flex tw-w-full tw-h-12 tw-items-center tw-rounded-2xl tw-bg-dt-surface-page tw-p-1"
      >
        <!-- sliding active highlight -->
        <div
          class="tw-pointer-events-none tw-absolute tw-left-1 tw-top-1 tw-bottom-1 tw-w-[calc(50%-4px)] tw-rounded-2xl tw-bg-color-surface-elevated border-gradient-neuomorphic tw-shadow-neuomorphic-subtle-minimal tw-transition-transform tw-duration-300 tw-ease-out"
          [style.transform]="'translateX(' + activeTabIndex() * 100 + '%)'"
        ></div>
        @for (tab of tabs; track tab) {
          <button
            type="button"
            (click)="tabActive.set(tab)"
            class="tw-relative tw-z-10 tw-flex tw-h-full tw-flex-1 tw-items-center tw-justify-center tw-border-0 tw-bg-transparent tw-cursor-pointer"
          >
            <span
              class="tw-font-medium tw-text-[14px] tw-tracking-[0.005em] tw-transition-colors tw-duration-200"
              [ngClass]="
                tabActive() === tab ? 'tw-text-dt-text-action' : 'tw-text-dt-text-secondary'
              "
            >
              {{ tab }}
            </span>
          </button>
        }
      </div>

      <app-add-edit-transaction-form
        [tabActive]="tabActive()"
        [selectedAccount]="data.accountView"
        [currency]="data.accountView?.currency"
        (symbolAndCurrencyEqualChange)="onSymbolAndCurrencyEqualChange($event)"
      >
      </app-add-edit-transaction-form>

      <!-- Receipt / Invoice (optional) — sits between the form and the Save button, Transaction Details tab only -->
      @if (tabActive() === editTransactionTab.transactionDetails) {
        <div class="tw-flex tw-flex-col tw-gap-3 tw-w-full">
          <div
            class="tw-flex tw-w-full tw-h-[1px] tw-border tw-border-dt-slate-1 tw-shadow-border-bottom"
          ></div>
          <div class="tw-flex tw-items-center tw-justify-between">
            <span class="tw-text-[13px] sm:tw-text-[12px] tw-font-bold tw-text-dt-text-tertiary">{{
              "receiptInvoice" | i18n
            }}</span>
            <span class="tw-text-[12px] tw-text-dt-text-disabled">{{ "optional" | i18n }}</span>
          </div>

          <!-- Document linking option cards -->
          <div class="tw-flex tw-flex-row tw-gap-3 tw-w-full">
            <!-- Action 1: link a (new) document from the device -->
            <button
              type="button"
              (click)="linkDocument()"
              class="tw-flex tw-flex-1 tw-flex-col tw-items-center tw-justify-center tw-gap-2 tw-py-4 tw-px-2 tw-rounded-xl tw-bg-dt-surface-card tw-shadow-neuomorphic-card active:tw-shadow-neuomorphic-inset tw-transition-shadow"
            >
              <icon [name]="'upload'" [size]="6" [currentColor]="'dt-icon-today-primary'"></icon>
              <span
                class="tw-font-medium tw-text-[13px] tw-text-center tw-text-dt-text-secondary"
                >{{ "linkDocument" | i18n }}</span
              >
            </button>

            <!-- Action 2: mobile only — capture a photo to link -->
            @if (isNative) {
              <button
                type="button"
                (click)="takePhoto()"
                class="tw-flex tw-flex-1 tw-flex-col tw-items-center tw-justify-center tw-gap-2 tw-py-4 tw-px-2 tw-rounded-xl tw-bg-dt-surface-card tw-shadow-neuomorphic-card active:tw-shadow-neuomorphic-inset tw-transition-shadow"
              >
                <icon [name]="'receipt'" [size]="6" [currentColor]="'dt-icon-today-primary'"></icon>
                <span
                  class="tw-font-medium tw-text-[13px] tw-text-center tw-text-dt-text-secondary"
                  >{{ "takePhoto" | i18n }}</span
                >
              </button>
            }

            <!-- Action 3: choose an existing file from the cabinet to link -->
            <button
              type="button"
              (click)="linkFromCabinet()"
              class="tw-flex tw-flex-1 tw-flex-col tw-items-center tw-justify-center tw-gap-2 tw-py-4 tw-px-2 tw-rounded-xl tw-bg-dt-surface-card tw-shadow-neuomorphic-card active:tw-shadow-neuomorphic-inset tw-transition-shadow"
            >
              <icon [name]="'cabinet'" [size]="6" [currentColor]="'dt-icon-today-primary'"></icon>
              <span
                class="tw-font-medium tw-text-[13px] tw-text-center tw-text-dt-text-secondary"
                >{{ "linkFromCabinet" | i18n }}</span
              >
            </button>
          </div>
        </div>
      }

      <button
        type="button"
        (click)="submit()"
        [attr.aria-busy]="submitting || null"
        class="tw-flex tw-w-full tw-items-center tw-justify-center tw-py-4 tw-px-6 tw-rounded-[50px] tw-bg-dt-surface-on-action tw-shadow-button-shadow"
      >
        <span
          class="tw-font-medium tw-text-[20px] sm:tw-text-[18px] tw-tracking-[0.005em] tw-leading-[135%] tw-text-dt-slate-0 tw-whitespace-nowrap"
          >{{ "save" | i18n }}</span
        >
      </button>
    </div>
  </div>
</div>
